<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryStockReturnResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                                <template #left-header>
                                    <em-button
                                        type='search'
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="扫码识别"
                                        showName
                                        @click="openScannerDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-warehouse"
                                               :disabled="$_notChecked || notSupportStockReturn()"
                                               custom-label="退库"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openStockReturnDialog()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="退库" width="50%" :visible.sync="stockReturnDialogVisible" :close-on-click-modal='false'
                   :close-on-press-escape="!batchConfirmReturnLoading" :show-close="!batchConfirmReturnLoading" append-to-body
                   @close='clearReturnForm'>
            <el-form :model="returnForm" ref="returnForm" label-width="auto" size="mini" :rules="rules">
                <el-form-item label="Storage Type" prop="storageType">
                    <el-input v-model="returnForm.storageType"></el-input>
                </el-form-item>
                <el-form-item label="BIN位" prop="storageBin">
                    <el-input v-model="returnForm.storageBin"></el-input>
                </el-form-item>
                <el-form-item label="批次号" prop="batchNumber">
                    <el-input v-model="returnForm.batchNumber"></el-input>
                </el-form-item>
                <el-form-item label="BIN位已占容量" prop="occupiedCapacity">
                    <el-input v-model="returnForm.occupiedCapacity"></el-input>
                </el-form-item>
            </el-form>
            <el-dialog title="扫一扫" :center="true" :visible.sync="binScannerVisible" append-to-body
                       @close="closeBinScanner" :close-on-click-modal='false'>
                <qr-code-scanner ref="binScanner" @getCodeData='getBinInfo'>
                </qr-code-scanner>
            </el-dialog>

            <execute-view-table v-show="showExecuteView"
                                ref="executeView"
                                style="max-height: 350px;"
                                :entity-name="modelName"
                                :rows="checkedRows">
            </execute-view-table>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="batchConfirmReturnLoading" @click="openBinScanner()">扫描BIN位码</el-button>
                <el-button :disabled="batchConfirmReturnLoading" @click="stockReturnDialogVisible = false">取 消</el-button>
                <el-button type="primary"
                           :disabled="batchConfirmReturnLoading"
                           :loading="batchConfirmReturnLoading"
                           @click="stockReturn()">确认退库</el-button>
            </div>
        </el-dialog>
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body
                   @close="closeScannerDialog" :close-on-click-modal='false'>
            <qr-code-scanner ref="returnTaskScanner" @getCodeData='getReturnTask'>
            </qr-code-scanner>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2022-01-19 17:43:54

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import ExecuteViewTable, {RUN} from "@/components/common/display/ExecuteViewTable.vue";
import executeSequentially from "@/utils/executeSequentially";

export default {
    name: "sithMesInventoryStockReturnListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, emTableCheckedMixin],
    components: {ExecuteViewTable, qrCodeScanner},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            stockReturnDialogVisible: false,
            returnForm: {
                storageType: '',
                storageBin: '',
                batchNumber: '',
                occupiedCapacity: '',
            },
            rules: {
                storageType: [{required: true, message: '请输入StorageType'}],
                storageBin: [{required: true, message: '请输入BIN位'}],
            },
            scannerVisible: false,
            binScannerVisible: false,
            batchConfirmReturnLoading: false,
            showExecuteView: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
    },
    mounted() {
        if (this.$route.query.id) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
        }
        if (this.$route.query.orderCode) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', this.$route.query.orderCode);
        }
        if (this.$route.query.materialCode) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', this.$route.query.materialCode);
        }
        this.$refs.emListFilter.doQuery();
    },
    methods: {
        notSupportStockReturn() {
            return this.checkedRows.some(row => row.returnTime && row.storageBin);
        },
        openStockReturnDialog() {
            this.stockReturnDialogVisible = true;
        },
        clearReturnForm() {
            if (this.showExecuteView) {
                this.$refs.emListFilter.doQuery();
            }
            this.returnForm.storageType = '';
            this.returnForm.storageBin = '';
            this.returnForm.batchNumber = '';
            this.returnForm.occupiedCapacity = '';
            this.batchConfirmReturnLoading = false;
            this.showExecuteView = false;
            if (this.$refs.returnForm) {
                this.$refs.returnForm.resetFields();
            }
            if (this.$refs.executeView) {
                this.$refs.executeView.clearRunningStatus();
            }
        },
        stockReturn() {
            if (this.batchConfirmReturnLoading) {
                return;
            }
            let self = this;
            self.$refs["returnForm"].validate(valid => {
                if (valid) {
                    self.batchConfirmReturnLoading = true;
                    self.showExecuteView = true;
                    const ids = [...self.checkedItems];
                    const form = Object.assign({}, self.returnForm);
                    const executeView = self.$refs.executeView;

                    executeSequentially(ids, {
                        shouldSkip: id => executeView.checkSuccess(id),
                        onStart: id => executeView.setStatus(id, RUN.START),
                        execute: id => self.$store.dispatch("api/post", {
                            url: `${self.$_emApiMixin_entityBaseApi("sithMesInventoryStockReturn")}/confirmReturn?id=${id}`,
                            data: form,
                            commonErrorHandle: false,
                        }).then(response => {
                            if (response.status !== 200) {
                                throw new Error("退库失败");
                            }
                            return response;
                        }),
                        onSuccess: id => executeView.setStatus(id, RUN.DONE),
                        onFailure: (id, error) => executeView.setStatus(
                            id,
                            RUN.FAILED,
                            self.getBatchErrorMessage(error, "退库失败")
                        ),
                    }).finally(() => {
                        self.batchConfirmReturnLoading = false;
                        if (executeView.checkAllSuccess()) {
                            self.$message.success("批处理成功");
                            self.stockReturnDialogVisible = false;
                        } else {
                            self.$message.warning("批处理完成，存在失败的条目");
                        }
                    });
                }
            });
        },
        getBatchErrorMessage(error, fallback) {
            return error && error.response && error.response.data && error.response.data.message
                || error && error.message
                || fallback;
        },
        openScannerDialog() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.returnTaskScanner.openCamera('');
            }, 500);
        },
        openBinScanner() {
            this.binScannerVisible = true;
            setTimeout(() => {
                this.$refs.binScanner.openCamera('');
            }, 500);
        },
        getReturnTask(data) {
            console.log("get qr code data:" + data);
            this.scannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var materialCode = obj['物料号'];
                // var orderCode = obj.orderCode;
                console.log(materialCode);
                // console.log(orderCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            // this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', orderCode);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', materialCode);
            this.$refs.emListFilter.doQuery();
        },
        getBinInfo(data) {
            console.log("bin code data:" + data);
            this.binScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var storageType = obj['Storage Type'];
                var storageBin = obj['Storage Bin'];
                console.log(storageType);
                console.log(storageBin);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.returnForm.storageType = storageType;
            self.returnForm.storageBin = storageBin;
        },
        closeScannerDialog() {
            this.$refs.returnTaskScanner.closeCamera();
            this.$refs.returnTaskScanner.resetOutputData();
            this.scannerVisible = false;
        },
        closeBinScanner() {
            this.$refs.binScanner.closeCamera();
            this.$refs.binScanner.resetOutputData();
            this.binScannerVisible = false;
        },
    }
};
</script>
